import React from "react";
import { Soil } from "./Soil";

export const SoilBE = (props) => <Soil {...props} triangle="beTexture" textBreak={true} />;
